import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { ConfiguracionApi } from './../../core/interfaces/configuracion-api';
import { ConfiguracionApiService } from './../../core/servicios/configuracion-api.service';

import { QueryService } from './../../core/servicios/-query.service';
import { Sessionadmin } from './../../core/interfaces/sessionadmin';
import { Sessionempleado } from './../../core/interfaces/sessionempleado';
import { Sessiontercero } from './../../core/interfaces/sessiontercero';
import { AuthService } from './../../core/servicios/auth.service';

@Component({
  selector: 'app-configuracion-api',
  templateUrl: './configuracion-api.component.html',
  styleUrls: ['./configuracion-api.component.css']
})
export class ConfiguracionApiComponent implements OnInit {

  public form: FormGroup;
  public isVerificar = false;
  public isLoading = false;
  public showApiKey = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private service: ConfiguracionApiService,
    private queryService: QueryService,
    private authService: AuthService,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.validar('_view');
    this.loadConfiguration();
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      id: [null],
      fecha: [null],
      nombre: ['callbell', Validators.required],
      api_key: [null, Validators.required],
      api_url: ['https://api.callbell.eu/v1', Validators.required],
      channel_uuid: [null],
      webhook_url: [null],
      estado: ['Activo', Validators.required],
      fecha_actualizacion: [null],
    });
  }

  private loadConfiguration(): void {
    this.isLoading = true;
    this.service.get(1).subscribe(
      (response: ConfiguracionApi) => {
        this.form.patchValue(response);
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  public toggleShowApiKey(): void {
    this.showApiKey = !this.showApiKey;
  }

  public save(event: Event): void {
    event.preventDefault();

    if (this.form.invalid) {
      this.isVerificar = true;
      return;
    }

    this.validar('_update').then(() => {
      const object: ConfiguracionApi = this.form.value;

      this.service.put(object).subscribe(
        (response: ConfiguracionApi) => {
          Swal.fire({
            icon: 'success',
            html: 'Configuración actualizada correctamente.',
            showConfirmButton: true,
            timer: 3000
          });
        },
        (error) => {
          Swal.fire({
            icon: 'error',
            html: 'Error al actualizar la configuración.',
            showConfirmButton: true
          });
        }
      );
    }).catch(() => {
      Swal.fire({
        icon: 'error',
        html: 'Acción no permitida.',
        showConfirmButton: true,
        timer: 3000
      });
    });
  }

  validar(accion: string) {
    const promise = new Promise((resolve, reject) => {
      let modulo = 'ConfiguracionAPI';

      if (this.authService.validar() === 'Admin') {
        const sessionadmin: Sessionadmin = this.authService.obtenerAdmin();

        this.queryService.query_1003(modulo, sessionadmin.fkadmin, accion, 'Admin').subscribe(
          () => {
            resolve(true);
          },
          error => {
            if (accion === '_view') {
              this.router.navigate(['/dashboard']);
            } else {
              reject();
            }
          },
          () => {
          }
        );
      } else if (this.authService.validar() === 'Empleado') {
        const sessionempleado: Sessionempleado = this.authService.obtenerEmpleado();

        this.queryService.query_1003(modulo, sessionempleado.fkempleado, accion, 'Empleado').subscribe(
          () => {
            resolve(true);
          },
          error => {
            if (accion === '_view') {
              this.router.navigate(['/dashboard']);
            } else {
              reject();
            }
          },
          () => {
          }
        );
      } else if (this.authService.validar() === 'Tercero') {
        const sessiontercero: Sessiontercero = this.authService.obtenerTercero();

        this.queryService.query_1003(modulo, sessiontercero.nit, accion, 'Tercero').subscribe(
          () => {
            resolve(true);
          },
          error => {
            if (accion === '_view') {
              this.router.navigate(['/dashboard']);
            } else {
              reject();
            }
          },
          () => {
          }
        );
      }

    });

    return promise;
  }

}